module.exports = __webpack_public_path__ + "static/media/greenG-downloadDoc-icon.e7a9f0c8.png";